import axios from 'axios';

/**
 * Project Files API client for ERP Project Management
 * Note: axios.defaults.baseURL is already configured to '/api/' in request.js.
 * All endpoints here start with '/project-management/files' to resolve cleanly to '/api/project-management/files/...'.
 */

const BASE = '/project-management/files';

export const fetchFilesTree = async () => {
    const response = await axios.get(`${BASE}/tree`);
    return response.data;
};

export const fetchFiles = async (params = {}) => {
    const response = await axios.get(`${BASE}`, { params });
    return response.data;
};

export const uploadProjectFile = async (formData, onUploadProgress) => {
    const response = await axios.post(`${BASE}/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
    });
    return response.data;
};

export const getFileDownloadUrl = async (fileId) => {
    const response = await axios.get(`${BASE}/${fileId}/download`);
    return response.data;
};

export const getFilePreviewUrl = async (fileId) => {
    const response = await axios.get(`${BASE}/${fileId}/preview`);
    return response.data;
};

export const archiveProjectFile = async (fileId) => {
    const response = await axios.put(`${BASE}/${fileId}/archive`);
    return response.data;
};

export const restoreProjectFile = async (fileId) => {
    const response = await axios.put(`${BASE}/${fileId}/restore`);
    return response.data;
};

export const publishDeliverableToCRE = async (fileId) => {
    const response = await axios.post(`${BASE}/${fileId}/publish-to-cre`);
    return response.data;
};

export const syncCREFile = async (payload) => {
    const response = await axios.post(`${BASE}/cre-sync`, payload);
    return response.data;
};

export const classifyUpload = async (payload) => {
    const response = await axios.post(`${BASE}/classify-upload`, payload);
    return response.data;
};

